import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import * as actions from "./actiontypes";
import * as models from "./model";
import CustomerUserApi from "./customerUserApi";

import { push } from "redux-little-router";

export type CustomerUserAction =
      ({ type: typeof actions.LOAD_CUSTOMERUSERS_SUCCESS } & Payload<models.CustomerUserListModel[]>)
    | ({ type: typeof actions.CREATE_CUSTOMERUSER_SUCCESS } & Payload<models.CustomerUserDetailModel>)
    | ({ type: typeof actions.LOAD_CUSTOMERUSER_DETAIL_SUCCESS } & Payload<models.CustomerUserDetailModel>)
    | ({ type: typeof actions.SAVE_CUSTOMERUSER_SUCCESS } & Payload<models.CustomerUserDetailModel>)
    | ({ type: typeof actions.DELETE_CUSTOMERUSER_SUCCESS } & Payload<any>)
    | ({ type: typeof actions.ACTIVATE_CUSTOMERUSER_SUCCESS } & Payload<string>)
    | ({ type: typeof actions.DEACTIVATE_CUSTOMERUSER_SUCCESS } & Payload<string>);

export const loadCustomerUsersSuccess = (payload: models.CustomerUserListModel[]): CustomerUserAction => ({
    payload,
    type: actions.LOAD_CUSTOMERUSERS_SUCCESS
});

export const createCustomerUserSuccess = (payload: models.CustomerUserDetailModel): CustomerUserAction => ({
    payload,
    type: actions.CREATE_CUSTOMERUSER_SUCCESS
});

export const saveCustomerUserSuccess = (payload: models.CustomerUserDetailModel): CustomerUserAction => ({
    payload,
    type: actions.SAVE_CUSTOMERUSER_SUCCESS
});

export const deleteCustomerUserSuccess = (id: any): CustomerUserAction => ({
    payload: id,
    type: actions.DELETE_CUSTOMERUSER_SUCCESS
});

export const deactivateCustomerUserSuccess = (id: string): CustomerUserAction => ({
    payload: id,
    type: actions.DEACTIVATE_CUSTOMERUSER_SUCCESS
});

export const activateCustomerUserSuccess = (id: string): CustomerUserAction => ({
    payload: id,
    type: actions.ACTIVATE_CUSTOMERUSER_SUCCESS
});

export function createCustomerUser(customerUser: models.CustomerUserCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_CUSTOMERUSER, CustomerUserApi.create(customerUser));
        dispatch(createCustomerUserSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveCustomerUser(customerUser: models.CustomerUserEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_CUSTOMERUSER, CustomerUserApi.save(customerUser));

        dispatch(saveCustomerUserSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function deleteCustomerUser(id: any, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteCustomerUser", CustomerUserApi.delete(id));
        dispatch(deleteCustomerUserSuccess(id));
        dispatch(push(`${path}`, {}));
    };
}

export function loadCustomerUsers(finished: boolean = false) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadCustomerUsers", CustomerUserApi.getAll(finished));
        dispatch(loadCustomerUsersSuccess(result));
    };
}

export function deactivateCustomerUser(id: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deactivateCustomerUser", CustomerUserApi.deactivate(id));
        dispatch(deactivateCustomerUserSuccess(id));
    };
}

export function activateCustomerUser(id: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "activateCustomerUser", CustomerUserApi.activate(id));
        dispatch(activateCustomerUserSuccess(id));
    };
}

export const loadCustomerUserDetailSuccess = (customerUser: models.CustomerUserDetailModel) => ({
    payload: customerUser,
    type: actions.LOAD_CUSTOMERUSER_DETAIL_SUCCESS
});

export function loadCustomerUserDetail({ customerUserId }: { customerUserId: string }) {
    return async (dispatch: Dispatch, getState: () => models.AppState) => {
        const customerUser = getState().customerUsers.filter(c => c.id === customerUserId)[0];

        if (customerUser === undefined
            || customerUser.detailUpdated === undefined
            || customerUser.detailUpdated.isBefore(customerUser.listUpdated)) {

            const action = customerUser === undefined ? createCustomerUserSuccess : loadCustomerUserDetailSuccess;

            const result = await loadAndTrack(dispatch, "loadCustomerUserDetail", CustomerUserApi.detail(customerUserId));
            dispatch(action(result));
        }
    };
}
